import { Id, Nullable } from 'types/definitions'
import { IAMAPI } from './API'

export default class TermsOfUseStore {
  constructor(private api: IAMAPI) {}

  /**
   * Fetches the latest terms for the platform, or for the workspace provided.
   *
   * @param workspaceId
   * @returns
   */
  async fetchLatestTerms(workspaceId: Nullable<Id>) {
    if (workspaceId) {
      return this.api.termsOfUse.getLatestForWorkspace(workspaceId)
    }
    return this.api.termsOfUse.getLatestForPlatform()
  }

  /**
   * Accepts the latest terms for the platform, or for the workspace provided.
   *
   * @param workspaceId
   * @returns
   */
  async acceptLatestTerms(workspaceId: Nullable<Id>) {
    if (workspaceId) {
      return this.api.termsOfUse.acceptLatestForWorkspace(workspaceId)
    }
    return this.api.termsOfUse.acceptLatestForPlatform()
  }

  /**
   * Check if the latest terms of use has been accepted.
   *
   * @param workspaceId
   * @returns
   */
  async checkTermsOfUseAcceptance(workspaceId: Nullable<Id>) {
    return (
      workspaceId
        ? this.api.termsOfUse.checkAcceptanceForWorkspace(workspaceId)
        : this.api.termsOfUse.checkAcceptanceForPlatform()
    ).then((acceptance) => acceptance.accepted)
  }
}
